import { Ammocan } from "./model_ammocan";
import { Fridge } from "./model_fridge";
import { Centurion12 } from "./model_centurion12";
import { Centurion18 } from "./model_centurion18";
import { Centurion24 } from "./model_centurion24";
import { Centurion32 } from "./model_centurion32";
import { ClassicPlus25 } from "./model_classicPlus25";
import { ClassicPlus40 } from "./model_classicPlus40";
import { ClassicPlus50 } from "./model_classicPlus50";
import { ClassicExtreme60, ClassicSelect60 } from "./model_classicselect60";
import { Collector } from "./model_collector";
import { Colonial23 } from "./model_colonial23";
import { Colonial30 } from "./model_colonial30";
import { Colonial50 } from "./model_colonial50";
import { Colonial50extreme } from "./model_colonial50extreme";
import { FatboyExtreme } from "./model_fatboyExtreme";
import { FatboyJrExtreme } from "./model_fatboyJrExtreme";
import { FatboyJrXl } from "./model_fatboyJrXl";
import { Franklin23 } from "../models/model_franklin23";
import { Franklin40 } from "../models/model_franklin40";
import { Franklin50 } from "../models/model_franklin50";
import { Franklinn29 } from "./model_franklinn29";
import { Franklinn40 } from "../models/model_franklinn40";
import { Franklinn50 } from "../models/model_franklinn50";
import { Franklinnn29 } from "./model_franklinnn29";
import { Franklinnn40 } from "../models/model_franklinnn40";
import { Franklinnn50 } from "../models/model_franklinnn50";
import { Freedom30 } from "./model_freedom30";
import { Freedom36 } from "./model_freedom36";
import { Freedom48 } from "./model_freedom48";
import { LibertyHome12 } from "../models/model_libertyhome12";
import { LibertyHome8 } from "../models/model_libertyhome8";
import { HomesafeSe } from "./model_libertyhomese";
import { Lincoln25 } from "../models/model_lincoln25";
import { Lincoln40 } from "../models/model_lincoln40";
import { Lincoln50 } from "../models/model_lincoln50";
import { NationalMagnum25 } from "./model_nationalMagnum25";
import { NationalMagnum40 } from "./model_nationalMagnum40";
import { NationalMagnum50 } from "./model_nationalMagnum50";
import { PremiumHome12 } from "../models/model_premiumHome12";
import { PremiumHome17 } from "../models/model_premiumHome17";
import { PremiumHome8 } from "../models/model_premiumHome8";
import { Presidential25 } from "../models/model_presidential25";
import { Presidential40 } from "../models/model_presidential40";
import { Presidential50 } from "../models/model_presidential50";
import { Tactical24 } from "../models/model_tactical24";
import { Usa30 } from "../models/model_usa30";
import { Usa36 } from "../models/model_usa36";
import { Usa48 } from "../models/model_usa48";
import { Usa50 } from "../models/model_usa50";
import { VaultBeast } from "../models/model_vaultbeast";
import { VaultBlockade } from "../models/model_vaultblockade";
import { Colonial23Pro } from "./model_colonial23Pro";
import { Colonial30Pro } from "./model_colonial30Pro";
import { Colonial50Pro } from "./model_colonial50Pro";
import { FatboyJr } from "./model_fatboyJr";
import { Fatboy } from "./model_fatboy";
import { CollectorT } from "./model_collectort";

//region AmmoCan
export const AmmoCanModels = {
  Ammocan: {
    model: Ammocan,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.505,
      width: 0.6125,
      depth: 0.49,
      textHeight: '60"',
      textWidth: '24"',
      textDepth: '20"',
    },
  },
};
//endregion
//region AmmoCan
export const FridgeModels = {
  Fridge: {
    model: Fridge,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.505,
      width: 0.6125,
      depth: 0.49,
      textHeight: '60"',
      textWidth: '24"',
      textDepth: '20"',
    },
  },
};
//endregion
//region Centurion
export const CenturionModels = {
  centurion12: {
    model: Centurion12,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5051,
      width: 0.461,
      depth: 0.39,
      textHeight: '59.5"',
      textWidth: '18.25"',
      textDepth: '16"',
    },
  },
  centurion18: {
    model: Centurion18,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5051,
      width: 0.6,
      depth: 0.49,
      textHeight: '59.5"',
      textWidth: '24.25"',
      textDepth: '20"',
    },
  },
  centurion24: {
    model: Centurion24,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5051,
      width: 0.761,
      depth: 0.49,
      textHeight: '59.5"',
      textWidth: '28.25"',
      textDepth: '20"',
    },
  },
  centurion32: {
    model: Centurion32,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5051,
      width: 0.7,
      depth: 0.6223,
      textHeight: '59.5"',
      textWidth: '28.25"',
      textDepth: '24.5"',
    },
  },
};
//endregion
//region ClassicPlus
export const ClassicPlusModels = {
  classicplus25: {
    model: ClassicPlus25,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.761,
      depth: 0.61,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '25.25"',
    },
  },
  classicplus40: {
    model: ClassicPlus40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.685,
      width: 0.9144,
      depth: 0.6834,
      textHeight: '66.5"',
      textWidth: '36"',
      textDepth: '27.75"',
    },
  },
  classicplus50: {
    model: ClassicPlus50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.066,
      depth: 0.701,
      textHeight: '72.5"',
      textWidth: '42.25"',
      textDepth: '27.75"',
    },
  },
};
//endregion
//region ClassicSelect
export const ClassicSelectModels = {
  classicselect60: {
    model: ClassicSelect60,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.84,
      width: 1.265,
      depth: 0.675,
      textHeight: '72.5"',
      textWidth: '50"',
      textDepth: '27.75"',
    },
  },
};
//endregion
//region Colonial
export const ColonialModels = {
  colonial23: {
    model: Colonial23,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.761,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  colonial30: {
    model: Colonial30,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.91,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '36"',
      textDepth: '22"',
    },
  },
  colonial50: {
    model: Colonial50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.0668,
      depth: 0.685,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
  colonial50extreme: {
    model: Colonial50extreme,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.066,
      depth: 0.685,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion

//region Colonial
export const ColonialNewModels = {
  colonial23standard: {
    model: Colonial23,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.761,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  colonial23proflex: {
    model: Colonial23Pro,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.761,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  colonial30standard: {
    model: Colonial30,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.91,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '36"',
      textDepth: '22"',
    },
  },
  colonial30proflex: {
    model: Colonial30Pro,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.91,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '36"',
      textDepth: '22"',
    },
  },
  colonial50standard: {
    model: Colonial50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.0668,
      depth: 0.685,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
  colonial50proflex: {
    model: Colonial50Pro,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.0668,
      depth: 0.685,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
  colonial50extreme: {
    model: Colonial50extreme,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.841,
      width: 1.066,
      depth: 0.685,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  }
};
//endregion

//region Fatboy
export const FatboyModels = {
  // fatboyjrextreme: {
  //   model: FatboyJrExtreme,
  //   measureToolProps: {
  //     cap_t: 0.002,
  //     cap_e: 0.002,
  //     height: 1.535,
  //     width: 1.06,
  //     depth: 0.55,
  //     textHeight: '60.5"',
  //     textWidth: '42"',
  //     textDepth: '22"',
  //   },
  // },
  fatboyjr: {
    model: FatboyJr,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.535,
      width: 1.06,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '42"',
      textDepth: '22"',
    },
  },
  fatboyjrxl: {
    model: FatboyJrXl,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.536,
      width: 1.065,
      depth: 0.682,
      textHeight: '60.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
  // fatboyextreme: {
  //   model: FatboyExtreme,
  //   measureToolProps: {
  //     cap_t: 0.002,
  //     cap_e: 0.002,
  //     height: 1.535,
  //     width: 1.062,
  //     depth: 0.52,
  //     textHeight: '60.5"',
  //     textWidth: '42"',
  //     textDepth: '27.5"',
  //   },
  // },
  fatboy: {
    model: Fatboy,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.535,
      width: 1.062,
      depth: 0.52,
      textHeight: '60.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion
//region Franklin
export const FranklinModels = {
  franklin23: {
    model: Franklin23,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.536,
      width: 0.76,
      depth: 0.6,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  franklin40: {
    model: Franklin40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.689,
      width: 0.89,
      depth: 0.688,
      textHeight: '66.5"',
      textWidth: '36"',
      textDepth: '27.5"',
    },
  },
  franklin50: {
    model: Franklin50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.8415,
      width: 1.066,
      depth: 0.688,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion

//region Franklinn
export const FranklinnModels = {
  franklin29: {
    model: Franklinn29,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.524,
      width: 0.76,
      depth: 0.6985,
      textHeight: '60"',
      textWidth: '30"',
      textDepth: '27.5"',
    },
  },
  franklin40: {
    model: Franklinn40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.689,
      width: 0.89,
      depth: 0.688,
      textHeight: '66.5"',
      textWidth: '36"',
      textDepth: '27.5"',
    },
  },
  franklin50: {
    model: Franklinn50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.8415,
      width: 1.066,
      depth: 0.688,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion

//region Franklinnn
export const FranklinnnModels = {
  franklin29: {
    model: Franklinnn29,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.524,
      width: 0.76,
      depth: 0.6985,
      textHeight: '60"',
      textWidth: '30"',
      textDepth: '27.5"',
    },
  },
  franklin40: {
    model: Franklinnn40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.689,
      width: 0.89,
      depth: 0.688,
      textHeight: '66.5"',
      textWidth: '36"',
      textDepth: '27.5"',
    },
  },
  franklin50: {
    model: Franklinnn50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.8415,
      width: 1.066,
      depth: 0.688,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion

//region Freedom
export const FreedomModels = {
  freedom30: {
    model: Freedom30,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.75,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  freedom36: {
    model: Freedom36,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.901,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '36"',
      textDepth: '22"',
    },
  },
  freedom48: {
    model: Freedom48,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 1.06,
      depth: 0.55,
      textHeight: '60.5"',
      textWidth: '42"',
      textDepth: '22"',
    },
  },
};
//endregion
//region Homesafes
export const HomesafesModels = {
  libertyhome8: {
    model: LibertyHome8,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 0.765175,
      width: 0.612775,
      depth: 0.494,
      textHeight: '30.125"',
      textWidth: '24.125"',
      textDepth: '20"',
    },
  },
  libertyhome12: {
    model: LibertyHome12,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.0705,
      width: 0.612775,
      depth: 0.508,
      textHeight: '42.125"',
      textWidth: '24.125"',
      textDepth: '20"',
    },
  },
};
//endregion
//region Homesafes
export const HomesafesSeModels = {
  HomesafeSe: {
    model: HomesafeSe,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 0.7112,
      depth: 0.494,
      textHeight: '60.5"',
      textWidth: '28"',
      textDepth: '20"',
    },
  },
};
//endregion
//region Collector
export const CollectorModels = {
  collector: {
    model: Collector,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 1.3716,
      depth: 0.6985,
      textHeight: '60.5"',
      textWidth: '54"',
      textDepth: '27.5"',
    },
  },
  collectort: {
    model: CollectorT,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5367,
      width: 1.3716,
      depth: 0.6985,
      textHeight: '60.566"',
      textWidth: '546"',
      textDepth: '27.56"',
    },
  }
};
//endregion
//region Lincoln
export const LincolnModels = {
  lincoln25: {
    model: Lincoln25,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.536,
      width: 0.76,
      depth: 0.605,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '24"',
    },
  },
  lincoln40: {
    model: Lincoln40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.687,
      width: 0.914,
      depth: 0.689,
      textHeight: '66.5"',
      textWidth: '36"',
      textDepth: '27.5"',
    },
  },
  lincoln50: {
    model: Lincoln50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.832,
      width: 1.0668,
      depth: 0.689,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion
//region National Magnum
export const NationalMagnumModels = {
  nationalmagnum25: {
    model: NationalMagnum25,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.517,
      width: 0.76,
      depth: 0.6,
      textHeight: '60.5"',
      textWidth: '30.25"',
      textDepth: '24.75"',
    },
  },
  nationalmagnum40: {
    model: NationalMagnum40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.68,
      width: 0.89,
      depth: 0.68,
      textHeight: '66.5"',
      textWidth: '36.25"',
      textDepth: '27.75"',
    },
  },
  nationalmagnum50: {
    model: NationalMagnum50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.83,
      width: 1.0656,
      depth: 0.68,
      textHeight: '72.5"',
      textWidth: '42.25"',
      textDepth: '27.75"',
    },
  },
};
//endregion
//region PremiumSafes
export const PremiumSafesModels = {
  premiumhome8: {
    model: PremiumHome8,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 0.7653,
      width: 0.613,
      depth: 0.493,
      textHeight: '29.75"',
      textWidth: '24.5"',
      textDepth: '19"',
    },
  },
  premiumhome12: {
    model: PremiumHome12,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.06,
      width: 0.622,
      depth: 0.48,
      textHeight: '41.75"',
      textWidth: '24.5"',
      textDepth: '19"',
    },
  },
  premiumhome17: {
    model: PremiumHome17,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.53035,
      width: 0.621,
      depth: 0.48,
      textHeight: '60.25"',
      textWidth: '24.5"',
      textDepth: '19"',
    },
  },
};
//endregion
//region Presidential
export const PresidentialModels = {
  presidential25: {
    model: Presidential25,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.525,
      width: 0.757,
      depth: 0.6,
      textHeight: '60.5"',
      textWidth: '30.25"',
      textDepth: '24.75"',
    },
  },
  presidential40: {
    model: Presidential40,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.688,
      width: 0.92,
      depth: 0.695,
      textHeight: '66.5"',
      textWidth: '36.25"',
      textDepth: '27.75"',
    },
  },
  presidential50: {
    model: Presidential50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.84,
      width: 1.07,
      depth: 0.695,
      textHeight: '72.5"',
      textWidth: '42.25"',
      textDepth: '27.75"',
    },
  },
};
//endregion
//region Tactical
export const TacticalModels = {
  tactical24: {
    model: Tactical24,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5055,
      width: 0.71,
      depth: 0.49,
      textHeight: '59.5"',
      textWidth: '28.25"',
      textDepth: '20"',
    },
  },
};
//endregion
//region Usa
export const UsaModels = {
  usa30: {
    model: Usa30,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.5305,
      width: 0.762,
      depth: 0.545,
      textHeight: '60.5"',
      textWidth: '30"',
      textDepth: '22"',
    },
  },
  usa36: {
    model: Usa36,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.534,
      width: 0.9,
      depth: 0.545,
      textHeight: '60.5"',
      textWidth: '36"',
      textDepth: '22"',
    },
  },
  usa48: {
    model: Usa48,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.535,
      width: 1.065,
      depth: 0.545,
      textHeight: '60.5"',
      textWidth: '42"',
      textDepth: '22"',
    },
  },
  usa50: {
    model: Usa50,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 1.84,
      width: 1.066,
      depth: 0.69,
      textHeight: '72.5"',
      textWidth: '42"',
      textDepth: '27.5"',
    },
  },
};
//endregion
//region Vault
export const VaultModels = {
  vaultdoorbeast: {
    model: VaultBeast,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 2.1844,
      width: 1.1303,
      depth: 0.2,
      textHeight: '86"',
      textWidth: '44.5"',
      textDepth: '8"',},
  },
  vaultdoorblockade: {
    model: VaultBlockade,
    measureToolProps: {
      cap_t: 0.002,
      cap_e: 0.002,
      height: 2.17,
      width: 1.1303,
      depth: 0.27,
      textHeight: '85.75"',
      textWidth: '44.5"',
      textDepth: '10.5"',},
  },
};
//endregion